var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#828282",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M15 17c2.34 0 4.34.512 5.734 1.594 1.174.91 2.018 2.303 2.22 4.406H7.046c.2-2.103 1.045-3.495 2.219-4.406C10.66 17.512 12.659 17 15 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M15 6a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
  })));
};
export default SvgUser;